import { useState } from 'react';
import { supabase } from './supabase';
import bcrypt from 'bcryptjs';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const girisYap = async (e) => {
    e.preventDefault();
    setYukleniyor(true);
    setHata('');

    const { data, error } = await supabase
      .from('kullanicilar')
      .select('*')
      .eq('email', email)
      .single();

    setYukleniyor(false);

    if (error || !data) {
      setHata('E-posta veya şifre hatalı.');
      return;
    }

    const sifreGecerli = data.sifre.startsWith('$2')
      ? bcrypt.compareSync(sifre, data.sifre)
      : sifre === data.sifre;

    if (!sifreGecerli) {
      setHata('E-posta veya şifre hatalı.');
      return;
    }

    localStorage.setItem('kullanici', JSON.stringify(data));
    onLogin(data);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f0f2f5'
    }}>
      <div style={{
        background: 'white', padding: '40px', borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '360px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img
            src="/logo.png"
            alt="BYR SWORD"
            style={{ width: '200px', objectFit: 'contain', display: 'block', margin: '0 auto' }}
          />
        </div>

        <form onSubmit={girisYap}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px' }}>
              E-posta
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', border: '1px solid #ddd',
                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
              }}
              placeholder="ornek@byrsword.com"
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px' }}>
              Şifre
            </label>
            <input
              type="password"
              value={sifre}
              onChange={e => setSifre(e.target.value)}
              required
              style={{
                width: '100%', padding: '10px 12px', border: '1px solid #ddd',
                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
              }}
              placeholder="••••••••"
            />
          </div>

          {hata && (
            <div style={{
              background: '#fff0f0', border: '1px solid #ffcccc',
              color: '#cc0000', padding: '10px', borderRadius: '8px',
              marginBottom: '16px', fontSize: '14px'
            }}>
              {hata}
            </div>
          )}

          <button
            type="submit"
            disabled={yukleniyor}
            style={{
              width: '100%', padding: '12px', background: '#1a3a6b',
              color: 'white', border: 'none', borderRadius: '8px',
              fontSize: '15px', fontWeight: '600', cursor: 'pointer'
            }}
          >
            {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        {/* Kargo takip linki */}
        <div style={{ textAlign: 'center', marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #eee' }}>
          <a
            href="/takip"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              color: '#1a3a6b', fontSize: '13px', fontWeight: '600',
              textDecoration: 'none', padding: '8px 16px',
              background: '#EFF6FF', borderRadius: '8px',
              border: '1px solid #BFDBFE',
              transition: 'background 0.2s'
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#DBEAFE'}
            onMouseLeave={e => e.currentTarget.style.background = '#EFF6FF'}
          >
            📦 Kargo Takibiniz için tıklayın →
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;